import router from '@/router/router.js';

export default {
  namespaced: true,
  state: {
    loading: true,
    firstLoad: true,
    firstLobbyLoad: true,

    loading404: true,
  },

  getters: {
    isLoading: state => state.loading,
    isFirstLoad: state => state.firstLoad,
    isFirstLobbyLoad: state => state.firstLobbyLoad,

    isLoading404: state => state.loading404,
  },

  mutations: {
    LOADING(state, value) {
      state.loading = value
    },
    FIRST_LOAD(state, value) {
      state.firstLoad = value
    },
    LOAD_TIME(state, value) {
      state.appLoadTime = value
    },
    FIRST_LOBBY_LOAD(state, value) {
      state.firstLobbyLoad = value
    },

    LOADING_404(state, value) {
      state.loading404 = value
    }
  },

  actions: {
    load: ({commit}) => commit('LOADING', false),
    unload: ({commit}) => commit('LOADING', true),

    async lockOutClient({ rootGetters, dispatch }) {
      console.log('not logged in, lock out client')
      //requires timeout to register allow router view to render after set loaded
      setTimeout(async () => {
        let onSpaceOverview = router.currentRoute.name === 'area' && !rootGetters['guest/space/showLobby']
        if(router.currentRoute?.meta?.requiresAuth || onSpaceOverview) { //area route doesnt require auth because of lobby but need to go to login if logged out on space overview
          if(onSpaceOverview) await dispatch('routing/goToHome', null, {root: true})
          dispatch('api/auth/loginWithSSO', undefined, {root: true})
          dispatch('unload')
        }
      },200)
    },
    async loadAppToAuth({rootGetters, commit, dispatch}) {
      dispatch('load')
      commit('LOAD_TIME', Date.now())
      commit('FIRST_LOAD',false)
      //run change handler as change handler doesn't run on first load (from router.afterEach) if not logged in
      if(!rootGetters['routing/ifRequiresAuth'] && !rootGetters['routing/ifSSORedirect']) await dispatch('routing/changeHandler', [], {root: true})
    },
    async loadApp({rootGetters,commit,dispatch}) {
      //keep loading if authenticated whilst still signing up
      if(rootGetters['api/auth/isSigningUp']) {
        console.log('signing up')
        return
      }

      try {
        let routeOnLoad = router.currentRoute.path;
        dispatch('routing/change', routeOnLoad, {root: true})

        await dispatch('current_user/fetchUser', null, {root: true})

        await dispatch('routing/changeHandler', [], {root: true})

        dispatch('load')
        commit('LOAD_TIME', Date.now())
        commit('FIRST_LOAD',false)
        dispatch('analytics/updatedUserData', null, {root: true})
      } catch (error) {
        dispatch('analytics/loadAppError', error, {root: true})
        dispatch('lockOutClient')
        console.log('error', error)
        alert('There was an error loading the app. Please try again.')
      }
    },
  }
};
